import axios from './axios';
import { GuestOrderRequest, GuestOrderResponse, UserOrderResponse, Menu } from '../types/shop';
import { OrderDetailsResponse } from '../types/order';

export type { Menu } from '../types/shop';

export const calculateCartPrice = async (payload: {
  cartItems: { 
    productId: number; 
    quantity: number; 
    variantId?: number; 
    selectedOptions?: { [key: string]: string }; 
  }[];
  shippingMethodId: string | null;
  marketId: string;
  promoCodes: string[];
  pointsToUse?: number;
}) => {
  const response = await axios.post('/api/shop/calculate-price', payload);
  return response.data;
};

export const getOrderSummary = async (payload: {
  cartItems: { 
    productId: number; 
    quantity: number; 
    variantId?: number; 
    selectedOptions?: { [key: string]: string }; 
  }[];
  shippingMethodId: string | null;
  marketId: string;
  promoCodes: string[];
  pointsToUse?: number;
}) => {
  const response = await axios.post('/api/shop/order-summary', payload);
  return response.data;
};

export const getPaymentMethods = async () => {
  const response = await axios.get('/api/shop/payment-methods');
  return response.data;
};

export const createGuestOrder = async (payload: GuestOrderRequest): Promise<GuestOrderResponse> => {
  const response = await axios.post('/api/shop/orders/guest', payload);
  return response.data;
};

export const createOrder = async (payload: GuestOrderRequest): Promise<UserOrderResponse> => {
  const response = await axios.post('/api/shop/orders', payload);
  return response.data;
};

export const addToCart = async (payload: { 
  productId: number; 
  quantity: number; 
  variantId?: number; 
  selectedOptions?: { [key: string]: string }; 
}) => {
  const response = await axios.post('/api/shop/cart', payload);
  return response.data;
};

export const removeFromCart = async (cartId: number) => {
  const response = await axios.delete(`/api/shop/cart/${cartId}`);
  return response.data;
};

export const updateCartQuantity = async (payload: { cartId: number; quantity: number; variantId?: number; selectedOptions?: { [key: string]: string } }) => {
  const response = await axios.patch(`/api/shop/cart/${payload.cartId}`, { 
    quantity: payload.quantity,
    variantId: payload.variantId,
    selectedOptions: payload.selectedOptions
  });
  return response.data;
};

export const clearCart = async () => {
  const response = await axios.delete('/api/shop/cart/clear');
  return response.data;
};

export const getCart = async () => {
  const response = await axios.get('/api/shop/cart');
  return response.data;
};

export const getStripePublishableKey = async () => {
  const response = await axios.get('/api/stripe/publishable-key');
  return response.data;
};

export const initiatePayment = async (payload: {
  orderId: number;
  paymentMethodId: string;
}): Promise<{
  amount: number;
  currency: string;
  payment_intent_id: string;
  status: string;
  error?: string;
  client_secret?: string;
}> => {
  const response = await axios.post('/api/payments/initiate', payload);
  return response.data;
};

export const getOrderDetails = async (orderId: number): Promise<OrderDetailsResponse> => {
  const response = await axios.get(`/api/shop/orders/${orderId}`);
  return response.data;
};

export const getMenus = async (): Promise<Menu[]> => {
  const response = await axios.get('/api/shop/menus');
  return response.data;
}; 